import { useEffect, useState } from "react"
import { TableSchema, columnId, rowDataPreprocesor, handleDoubleClickRow } from "../../AreasListing/scheme"
import Copyright from "../../common/Copyright"
import { useNavigate } from "react-router-dom"
import { useProject } from "../../../context/ProjectContext"
import { filterAreas } from "../../../services/company.service"
import DataTable from "../../common/DataTable2"
import { DataArea } from "../../../models/area.model"


interface CompanyAreasListingProps {
  company_code: string
  setBlockScreen: (p: any) => void
}

const CompanyAreasListing: React.FC<CompanyAreasListingProps> = ({
  company_code,
  setBlockScreen,
}) => {
  const { selectedProject } = useProject()
  const navigate = useNavigate()
  const [areasList, setAreasList] = useState<DataArea[]>([]);
  const [loading, setLoading] = useState<boolean>(false)

  const initComponent = () => {
    setBlockScreen(true)
    Promise.all([setTimeout(() => { }, 500)]).then(function (result: any[]) {
      setBlockScreen(false)
    }).catch((error) => {
      setBlockScreen(false)
    })
  };

  useEffect(initComponent, [])

  const setFilter = () => {
    setLoading(true)
    Promise.all([filterAreas(selectedProject, { 'company_code': company_code })]).then(function (results) {
      setAreasList(results[0])
      setLoading(false)
    }).catch((error) => {
      setLoading(false)
    });
  }

  useEffect(setFilter, [selectedProject])

  const handleDoubleClickArea = (rowData: DataArea) => {
    handleDoubleClickRow(selectedProject, rowData.code, navigate)
  }

  return (
    <>
      <div className="areas-listing-section">
        <DataTable
          columns={TableSchema}
          rows={areasList.map((row) => rowDataPreprocesor(row, selectedProject))}
          onRowDoubleClick={handleDoubleClickArea}
          loading={loading}
          columnId={columnId}
          onClickIdValue={handleDoubleClickArea}
        />
      </div>
      <Copyright marginBottom={'1rem'} />
    </>
  )
}

export default CompanyAreasListing;